import { useParams, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { HowToVideosService } from '../../../services/howToVideosService'
import { HowToVideo } from '../../../../services/cellcast.type'
import VideoDetail from './components/VideoDetail'
import { getVideoThumbnail } from '../../../Utils/videoUtils'

const HowToVideoDetailPage = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [video, setVideo] = useState<HowToVideo | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (id) {
      HowToVideosService.getVideoById(id)
        .then(data => setVideo(data.data))
        .finally(() => setLoading(false))
    }
  }, [id])

  if (loading) return <div>Loading...</div>
  if (!video) return <div>Video not found</div>
console.log(video)
  return (

    <VideoDetail
      imagePath={getVideoThumbnail(video)}
      title={video.title}
      description={video.description}
      footerText={''}
      category={video.category || ''}
      article={video.subTitle || ''}
      item={video}
      onBackToList={() => navigate('/help/how-to-videos')}
      onCategoryClick={() => navigate(`/help/how-to-videos?category=${video.category}`)}
    />
  )
}

export default HowToVideoDetailPage
